import { useEffect, useState } from "react";
import { Badge, Card, CardBody, Col, Container, Row } from "reactstrap";
import BoxCard from "../../Counters/Card";

const MixedRolesCard = ({
  visitantes,
  proveedores,
  estudiantes,
  guardias,
  expatriados,
  onFilters,
}) => {
  const [hoveredV, setHoveredV] = useState(false);
  const [hoveredP, setHoveredP] = useState(false);
  const [hoveredG, setHoveredG] = useState(false);
  const [hoveredE, setHoveredE] = useState(false);

  return (
    <Col lg={4} xs={12} className="p-2">
      <Card
        className="text-white text-center shadow rounded"
        // style={{ background: "#1b3765" }}
        style={{ background: "#0d6efd" }}
      >
        <CardBody>
          <h4 className="fw-bold mb-3">Externos</h4>
          <div className="d-flex justify-content-center gap-2 flex-wrap">
            <Badge
              color="light"
              className="text-dark"
              style={{
                cursor: "pointer",
                transform: hoveredV ? "scale(1.05)" : "scale(1)",
                transition: "transform 0.3s ease-in-out",
              }}
              onClick={() => onFilters("pre_tipos_usuarios.code", "V")}
              onMouseEnter={() => setHoveredV(true)}
              onMouseLeave={() => setHoveredV(false)}
            >
              Visitantes: {visitantes}
            </Badge>
            <Badge
              color="light"
              className="text-dark"
              style={{
                cursor: "pointer",
                transform: hoveredP ? "scale(1.05)" : "scale(1)",
                transition: "transform 0.3s ease-in-out",
              }}
              onClick={() => onFilters("pre_tipos_usuarios.code", "P")}
              onMouseEnter={() => setHoveredP(true)}
              onMouseLeave={() => setHoveredP(false)}
            >
              Proveedores: {proveedores}
            </Badge>
            <Badge
              color="light"
              className="text-dark"
              style={{
                cursor: "pointer",
                transform: hoveredG ? "scale(1.05)" : "scale(1)",
                transition: "transform 0.3s ease-in-out",
              }}
              onClick={() => onFilters("pre_tipos_usuarios.code", "G")}
              onMouseEnter={() => setHoveredG(true)}
              onMouseLeave={() => setHoveredG(false)}
            >
              Guardias: {guardias}
            </Badge>
            <Badge
              color="light"
              className="text-dark"
              style={{
                cursor: "pointer",
                transform: hoveredE ? "scale(1.05)" : "scale(1)",
                transition: "transform 0.3s ease-in-out",
              }}
              onClick={() => onFilters("pre_tipos_usuarios.code", "E")}
              onMouseEnter={() => setHoveredE(true)}
              onMouseLeave={() => setHoveredE(false)}
            >
              Estudiantes: {estudiantes}
            </Badge>
            <Badge
              color="light"
              className="text-dark"
              style={{
                cursor: "pointer",
                transform: hoveredE ? "scale(1.05)" : "scale(1)",
                transition: "transform 0.3s ease-in-out",
              }}
              onClick={() => onFilters("pre_tipos_usuarios.code", "expatriado")}
              onMouseEnter={() => setHoveredE(true)}
              onMouseLeave={() => setHoveredE(false)}
            >
              Expatriados: {expatriados}
            </Badge>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

const AgruparUsuarios = ({ data, onFilters }) => {
  const [trabajadores, setTrabajadores] = useState([]);
  const [visitantes, setVisitantes] = useState([]);
  const [cuadrilla, setCuadrilla] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [estudiantes, setEstudiantes] = useState([]);
  const [guardias, setGuardias] = useState([]);
  const [expatriados, setExpatriados] = useState([]);
  const [sinCorreo, setSinCorreo] = useState([]);
  const [sinCodigo, setSinCodigo] = useState([]);
  const [usuariosInactivos, setUsuariosInactivos] = useState([]);

  const groupByTipo = (tipo, setFn) => {
    const res = data.filter(
      (d) => d.pre_tipos_usuarios?.code === tipo.toString()
    );
    setFn(res);
  };

  useEffect(() => {
    if (data.length > 0) {
      groupByTipo("trabajador", setTrabajadores);
      groupByTipo("cuadrilla", setCuadrilla);
      groupByTipo("V", setVisitantes);
      groupByTipo("P", setProveedores);
      groupByTipo("E", setEstudiantes);
      groupByTipo("G", setGuardias);
      groupByTipo("expatriado", setExpatriados);

      const sinCorreo = data.filter((d) => d.correo === "");
      const sinCodigo = data.filter((d) => d.code === "");
      const dadosDeBaja = data.filter((d) => !d.estado);

      setSinCorreo(sinCorreo);
      setSinCodigo(sinCodigo);
      setUsuariosInactivos(dadosDeBaja);
    }
  }, [data]);

  return (
    <Container fluid className="py-2">
      <Row className="justify-content-center">
        <BoxCard
          label="Trabajadores"
          count={trabajadores.length}
          onClick={() => onFilters("pre_tipos_usuarios.code", "trabajador")}
        />
        <BoxCard
          label="Cuadrilla"
          count={cuadrilla.length}
          onClick={() => onFilters("pre_tipos_usuarios.code", "cuadrilla")}
        />
        <MixedRolesCard
          visitantes={visitantes.length}
          proveedores={proveedores.length}
          estudiantes={estudiantes.length}
          guardias={guardias.length}
          expatriados={expatriados.length}
          onFilters={onFilters}
        />
        <BoxCard
          label="Sin Correo"
          count={sinCorreo.length}
          color="#dc3545"
          onClick={() => onFilters("correo", "")}
        />
        <BoxCard
          label="Sin Código"
          count={sinCodigo.length}
          color="#ffc107"
          onClick={() => onFilters("code", "")}
        />
        <BoxCard
          label="Usuarios Inactivos"
          color="grey"
          count={usuariosInactivos.length}
          onClick={() => onFilters("estado", false)}
        />
        <BoxCard
          label="Totales"
          count={data.length}
          onClick={() => onFilters("", "")}
        />
      </Row>
    </Container>
  );
};

export default AgruparUsuarios;
